<template>
  <LayoutContent>
    <AcknowledgementCard :title="$t('message.yourTransactionIsBeingProcessed')" :body="$t('message.transactionProcessTakesTimeToProcess')" />
  </LayoutContent>
</template>

<script>
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AcknowledgementCard from '@/components/AcknowledgementCard.vue'

export default {
  name: 'TransferToBankAcknowledgement',
  components: { LayoutContent, AcknowledgementCard }
}
</script>
